import http from '@/plugins/axios/axios';

export default class ArquivoFolhaGlobusService {

    salvar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-globus/salvar', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-globus/listar', requisicao);
    } 
    
    exportarArquivoFolha(requisicao) {       
        return http.post('/api/documento/arquivo-folha-globus/folha-pag', requisicao, {responseType: 'blob'});
    } 
}